import { fetchData, apiURL } from "../api-helper";

const getCapacity = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products/capacity`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const products = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateProduct = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products/${payload.productId}`;
    fetchData(endpointURL, "put", payload.requestBody)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const uploadProductImages = (payload) => {
  return new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products/${payload.get("id")}/image`;
    fetchData(endpointURL, "postform", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCapacitySettings = (id) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/product/${id}/capacity_settings`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createCapacitySettings = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/product/${payload.product_id}/capacity_settings`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const editCapacitySettings = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/product/${payload.product_id}/capacity_settings/${payload.id}`;
    fetchData(endpointURL, "put", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteCapacitySettings = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/product/${payload.product_id}/capacity_settings/${payload.id}`;
    fetchData(endpointURL, "delete", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const productGroupList = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products/groups`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updatePorductGroup = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/products/groups/${payload.id}`;
    fetchData(endpointURL, "put", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  getCapacity,
  products,
  updateProduct,
  uploadProductImages,
  getCapacitySettings,
  createCapacitySettings,
  editCapacitySettings,
  deleteCapacitySettings,
  productGroupList,
  updatePorductGroup,
};
